/**
 * Reminder Origin
 */
export enum ReminderOrigin {
  InformalCaregiver = 'informal-caregiver',
  ProfessionalCaregiver = 'professional-caregiver',
}
